import logo from './logo.svg';
import { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { InputSwitch } from 'primereact/inputswitch';

import GlobalHeader from './components/GlobalHeader'
import GlobalNavigation from './components/GlobalNavigation'
import Card from './components/Card'
import Path from './components/Path'
import RecordHome from './components/RecordHome';
import RecordPageTabs from './components/RecordPageTabs';
import ThemingAgentBot from './components/ThemingAgentBot';
import ThemingWindow from './components/ThemingWindow';

function App() {
  const [useAgentInterface, setUseAgentInterface] = useState(false);
  
  const handleAgentIconClick = (message) => {
    if(document.getElementById("Base").classList.contains('agent-open')) {
      document.getElementById("Base").classList.remove('agent-open');
      document.getElementById("App").classList.add('slds-size_4-of-4');
      document.getElementById("App").classList.remove('slds-size_3-of-4');
    }
    else {
      document.getElementById("Base").classList.add('agent-open');
      document.getElementById("App").classList.remove('slds-size_4-of-4');
      document.getElementById("App").classList.add('slds-size_3-of-4');
    }
  }

  return (
    <div id="Base" className='slds-grid'>
      <div id="App" className="App slds-col slds-size_4-of-4 slds-theming-scope">
        <GlobalHeader onIconClick={handleAgentIconClick}/>
        <GlobalNavigation />
        <RecordHome />
        <Card>
          <Path />
        </Card>
        <RecordPageTabs className="slds-card"/>
    </div>
    <div
     className="Chatbot slds-col slds-size_1-of-4 slds-card slds-non-theming-scope">
      <div className="slds-grid slds-grid_align-end slds-p-right_medium slds-p-top_x-small">
        <div className="slds-grid slds-grid_vertical-align-center">
          <span className="slds-m-right_x-small">Standard UI</span>
          <InputSwitch 
            checked={useAgentInterface} 
            onChange={(e) => setUseAgentInterface(e.value)}
          />
          <span className="slds-m-left_x-small">Agentic UI</span>
        </div>
      </div>
      {useAgentInterface ? <ThemingAgentBot/> : <ThemingWindow/>}
     </div>
    </div>
  );
}

export default App;
